// extracted by mini-css-extract-plugin
module.exports = {"Text":"Title_Text__O7mKB","Numbers":"Title_Numbers__1n28j"};